module.exports = __webpack_public_path__ + "img/880-2969ac.png";